import React from "react";
import { styled } from "@mui/system";
import MUIRadio from "@mui/material/Radio";
import { RadioProps as RadioPropsMUI } from "@mui/material/Radio";
export interface RadioProps extends RadioPropsMUI {}

export const Radio: (props: RadioProps) => JSX.Element = styled(
  React.forwardRef<HTMLButtonElement, RadioProps>((props, ref) => (
    <MUIRadio ref={ref} {...props} />
  )),
  {
    name: "Radio",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiRadio-root	": {
    color: theme.palette.primary.primary,
    "&:hover": {
      background: "transparent"
    }
  },
  "&.MuiRadio-root.Mui-checked .MuiSvgIcon-root": {
    color: theme.palette.primary.blueColor
  },
  "&.MuiRadio-root.Mui-disabled .MuiSvgIcon-root": {
    color: theme.palette.primary.textDisabledColor
  },
  "&.MuiRadio-root.Mui-checked.Mui-disabled .MuiSvgIcon-root": {
    color: theme.palette.primary.textDisabledColor
  }
}));
